// Clear Associated Facility Matrics
export const CLEAR_RADPROFILE_ASSOCIATED_SITEMATRICS = 'CLEAR_RADPROFILE_ASSOCIATED_SITEMATRICS';

//Rad Profile Action Types
export const FETCH_RADPROFILE_REQUEST = 'FETCH_RADPROFILE_REQUEST';
export const FETCH_RADPROFILE_SUCCESS = 'FETCH_RADPROFILE_SUCCESS';
export const FETCH_RADPROFILE_FAILURE = 'FETCH_RADPROFILE_FAILURE';

// Rad Schedule Action Types
export const ADD_RAD_SCHEDULE_REQUEST = 'ADD_RAD_SCHEDULE_REQUEST';
export const ADD_RAD_SCHEDULE_SUCCESS = 'ADD_RAD_SCHEDULE_SUCCESS';
export const ADD_RAD_SCHEDULE_FAILURE = 'ADD_RAD_SCHEDULE_FAILURE';

// Save Rad Schedule Action Types
export const SAVE_RAD_SCHEDULE_REQUEST = 'SAVE_RAD_SCHEDULE_REQUEST';
export const SAVE_RAD_SCHEDULE_SUCCESS = 'SAVE_RAD_SCHEDULE_SUCCESS';
export const SAVE_RAD_SCHEDULE_FAILURE = 'SAVE_RAD_SCHEDULE_FAILURE';

// Update Rad Schedule Action Types
export const UPDATE_RAD_SCHEDULE_REQUEST = 'UPDATE_RAD_SCHEDULE_REQUEST';
export const UPDATE_RAD_SCHEDULE_SUCCESS = 'UPDATE_RAD_SCHEDULE_SUCCESS';
export const UPDATE_RAD_SCHEDULE_FAILURE = 'UPDATE_RAD_SCHEDULE_FAILURE';

// Rad Profile Task by Date Action Types
export const FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_REQUEST = 'FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_REQUEST';
export const FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_SUCCESS = 'FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_SUCCESS';
export const FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_FAILURE = 'FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_FAILURE';

// Rad Profile Associated Facility Matrics Action Types
export const FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_REQUEST = 'FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_REQUEST';
export const FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_SUCCESS = 'FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_SUCCESS';
export const FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_FAILURE = 'FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_FAILURE';

// Rad Facility Matrix Dropdown Action Types
export const FETCH_RAD_SITE_MATRIX_DROPDOWN_REQUEST = 'FETCH_RAD_SITE_MATRIX_DROPDOWN_REQUEST';
export const FETCH_RAD_SITE_MATRIX_DROPDOWN_SUCCESS = 'FETCH_RAD_SITE_MATRIX_DROPDOWN_SUCCESS';
export const FETCH_RAD_SITE_MATRIX_DROPDOWN_FAILURE = 'FETCH_RAD_SITE_MATRIX_DROPDOWN_FAILURE';

// Get Facility Metrics Child Table Action Types
export const FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_REQUEST = 'FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_REQUEST';
export const FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_SUCCESS = 'FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_SUCCESS';
export const FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_FAILURE = 'FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_FAILURE';

//GetRadiologist YTD By ID Action Types
export const FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_REQUEST = 'FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_REQUEST';
export const FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_SUCCESS = 'FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_SUCCESS';
export const FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_FAILURE = 'FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_FAILURE';

////dropdown bindings in the Update Schedule Information(Start)
export const FETCH_RAD_DROPDOWN_TASKS_REQUEST = 'FETCH_RAD_DROPDOWN_TASKS_REQUEST';
export const FETCH_RAD_DROPDOWN_TASKS_SUCCESS = 'FETCH_RAD_DROPDOWN_TASKS_SUCCESS';
export const FETCH_RAD_DROPDOWN_TASKS_FAILURE = 'FETCH_RAD_DROPDOWN_TASKS_FAILURE';
////dropdown bindings in the Update Schedule Information(End)

// Delete Shift Input Details Action Types
export const DELETE_SHIFT_INPUT_DETAILS_REQUEST = 'DELETE_SHIFT_INPUT_DETAILS_REQUEST';
export const DELETE_SHIFT_INPUT_DETAILS_SUCCESS = 'DELETE_SHIFT_INPUT_DETAILS_SUCCESS';
export const DELETE_SHIFT_INPUT_DETAILS_FAILURE = 'DELETE_SHIFT_INPUT_DETAILS_FAILURE';

// Get Schedules By Date Range Action Types
export const FETCH_SCHEDULES_BY_DATE_RANGE_REQUEST = 'FETCH_SCHEDULES_BY_DATE_RANGE_REQUEST';
export const FETCH_SCHEDULES_BY_DATE_RANGE_SUCCESS = 'FETCH_SCHEDULES_BY_DATE_RANGE_SUCCESS';
export const FETCH_SCHEDULES_BY_DATE_RANGE_FAILURE = 'FETCH_SCHEDULES_BY_DATE_RANGE_FAILURE';

// Schedule Request Action Types
export const FETCH_SCHEDULE_REQUEST_REQUEST = 'FETCH_SCHEDULE_REQUEST_REQUEST';
export const FETCH_SCHEDULE_REQUEST_SUCCESS = 'FETCH_SCHEDULE_REQUEST_SUCCESS';
export const FETCH_SCHEDULE_REQUEST_FAILURE = 'FETCH_SCHEDULE_REQUEST_FAILURE';

export const DELETE_SCHEDULE_REQUEST_REQUEST = 'DELETE_SCHEDULE_REQUEST_REQUEST';
export const DELETE_SCHEDULE_REQUEST_SUCCESS = 'DELETE_SCHEDULE_REQUEST_SUCCESS';
export const DELETE_SCHEDULE_REQUEST_FAILURE = 'DELETE_SCHEDULE_REQUEST_FAILURE';

// Provider Profile Provider Metrics -chart Action Types

export const GETRADIOLOGIST_PROFILE_CHART_DETAILS_REQUEST = 'GETRADIOLOGIST_PROFILE_CHART_DETAILS_REQUEST';
export const GETRADIOLOGIST_PROFILE_CHART_DETAILS_SUCCESS = 'GETRADIOLOGIST_PROFILE_CHART_DETAILS_SUCCESS';
export const GETRADIOLOGIST_PROFILE_CHART_DETAILS_FAILURE = 'GETRADIOLOGIST_PROFILE_CHART_DETAILS_FAILURE';

//Rad Profile Download Image

export const DOWNLOAD_RAD_PROFILE_IMAGE_REQUEST = 'DOWNLOAD_RAD_PROFILE_IMAGE_REQUEST';
export const DOWNLOAD_RAD_PROFILE_IMAGE_SUCCESS = 'DOWNLOAD_RAD_PROFILE_IMAGE_SUCCESS';
export const DOWNLOAD_RAD_PROFILE_IMAGE_FAILURE = 'DOWNLOAD_RAD_PROFILE_IMAGE_FAILURE';

// Rad Profile Delete Image

export const DELETE_RAD_PROFILE_IMAGE_REQUEST = 'DELETE_RAD_PROFILE_IMAGE_REQUEST';
export const DELETE_RAD_PROFILE_IMAGE_SUCCESS = 'DELETE_RAD_PROFILE_IMAGE_SUCCESS';
export const DELETE_RAD_PROFILE_IMAGE_FAILURE = 'DELETE_RAD_PROFILE_IMAGE_FAILURE';

// Rad Profile Save Image
export const SAVE_RAD_PROFILE_IMAGE_REQUEST = 'SAVE_RAD_PROFILE_IMAGE_REQUEST';
export const SAVE_RAD_PROFILE_IMAGE_SUCCESS = 'SAVE_RAD_PROFILE_IMAGE_SUCCESS';
export const SAVE_RAD_PROFILE_IMAGE_FAILURE = 'SAVE_RAD_PROFILE_IMAGE_FAILURE';

// Rad Profile Verification (Staffing Agency / Primary Address)
export const SAVE_RAD_PROFILE_VERIFICATION_REQUEST = 'SAVE_RAD_PROFILE_VERIFICATION_REQUEST';
export const SAVE_RAD_PROFILE_VERIFICATION_SUCCESS = 'SAVE_RAD_PROFILE_VERIFICATION_SUCCESS';
export const SAVE_RAD_PROFILE_VERIFICATION_FAILURE = 'SAVE_RAD_PROFILE_VERIFICATION_FAILURE';

// Provider Metrics Dropdown Action Types
export const FETCH_RAD_PROVIDER_METRICS_DROPDOWN_REQUEST = 'FETCH_RAD_PROVIDER_METRICS_DROPDOWN_REQUEST';
export const FETCH_RAD_PROVIDER_METRICS_DROPDOWN_SUCCESS = 'FETCH_RAD_PROVIDER_METRICS_DROPDOWN_SUCCESS';
export const FETCH_RAD_PROVIDER_METRICS_DROPDOWN_FAILURE = 'FETCH_RAD_PROVIDER_METRICS_DROPDOWN_FAILURE';

// Provider Metrics Chart Details Action Types
export const FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_REQUEST = 'FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_REQUEST';
export const FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_SUCCESS = 'FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_SUCCESS';
export const FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_FAILURE = 'FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_FAILURE';

// Rad Site Assignment Notes Action Types
export const FETCH_RAD_SITE_ASSIGNMENT_NOTES_REQUEST = 'FETCH_RAD_SITE_ASSIGNMENT_NOTES_REQUEST';
export const FETCH_RAD_SITE_ASSIGNMENT_NOTES_SUCCESS = 'FETCH_RAD_SITE_ASSIGNMENT_NOTES_SUCCESS';
export const FETCH_RAD_SITE_ASSIGNMENT_NOTES_FAILURE = 'FETCH_RAD_SITE_ASSIGNMENT_NOTES_FAILURE';

export const FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_REQUEST = 'FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_REQUEST';
export const FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_SUCCESS = 'FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_SUCCESS';
export const FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_FAILURE = 'FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_FAILURE';

export const ADD_RAD_SITE_ASSIGNMENT_NOTE_REQUEST = 'ADD_RAD_SITE_ASSIGNMENT_NOTE_REQUEST';
export const ADD_RAD_SITE_ASSIGNMENT_NOTE_SUCCESS = 'ADD_RAD_SITE_ASSIGNMENT_NOTE_SUCCESS';
export const ADD_RAD_SITE_ASSIGNMENT_NOTE_FAILURE = 'ADD_RAD_SITE_ASSIGNMENT_NOTE_FAILURE';

export const CLEAR_RAD_SITE_ASSIGNMENT_NOTES = 'CLEAR_RAD_SITE_ASSIGNMENT_NOTES';
export const CLEAR_RAD_SITE_ASSIGNMENT_ALL_NOTES = 'CLEAR_RAD_SITE_ASSIGNMENT_ALL_NOTES';
export const RESET_ADD_RAD_SITE_ASSIGNMENT_NOTE_SUCCESS = 'RESET_ADD_RAD_SITE_ASSIGNMENT_NOTE_SUCCESS';

// Rad Task Facilities (collapsible "Facilities" section, owner-keyed)
export const FETCH_RAD_TASK_FACILITIES_REQUEST = 'FETCH_RAD_TASK_FACILITIES_REQUEST';
export const FETCH_RAD_TASK_FACILITIES_SUCCESS = 'FETCH_RAD_TASK_FACILITIES_SUCCESS';
export const FETCH_RAD_TASK_FACILITIES_FAILURE = 'FETCH_RAD_TASK_FACILITIES_FAILURE';
export const CLEAR_RAD_TASK_FACILITIES = 'CLEAR_RAD_TASK_FACILITIES';